<template>
  <DefaultLayout>
    <template #content>
      <div v-if="!isLoggedIn" class="top-banner">
          <img :src="(isMobile)?BannerMobile:(isTablet)?BannerTablet:BannerDesktop" alt="Banner promocional">
          <div class="banner-content">
            <h1>Comprar y vender pallets</h1>
            <h2>Regístrate y pon tu anuncio gratis</h2>
            <router-link :to="{ name: 'register' }" class="btn-primary-m btn-primary-green">Regístrate gratis</router-link>
          </div>

        </div>
      <div class="container">
        <FiltersComponent
            :filters="filters"
            :numberFilters="numberFiltersApplied"
            @applyFilters="applyFiltersHandler"
            @clearFilters="clearFiltersHandler"
        />
        <div class="message-container">
          <span>Mostrando resultados en un radio de <b>{{ distance }}Km</b>.</span>
        </div>
        <MarketListComponent
            :filters="filters"
            :applyFiltersEvent="applyFiltersEvent"
        />
      </div>
    </template>
  </DefaultLayout>
</template>

<script setup lang="ts">
import FiltersComponent from '@/components/screens/Market/FiltersComponent.vue';
import MarketListComponent from '@/components/screens/Market/MarketListComponent.vue';
import DefaultLayout from '@/layouts/default/DefaultLayout.vue';
import { ref, onMounted } from 'vue';
import { fetchAndCombineFilters, lastSearch, lastNumFiltersApplied } from "@/services/frontend/FiltersService";
import { Filter } from "@/models/frontend/FeatureModels";
import {isTablet, isMobile} from "@/helpers/CommonHelper";
import BannerDesktop from '@/assets/images/Top-Banner-desktop_small.png';
import BannerTablet from '@/assets/images/Top-Banner-tablet_small.png';
import BannerMobile from '@/assets/images/Top-Banner-mobile_small.png';
import * as Session from "supertokens-web-js/recipe/session";

const filters = ref<Filter[]>([]);
const distance = ref<number>(0);
const appliedFilters = ref<Filter[]>([]);
const applyFiltersEvent = ref(0);
const numberFiltersApplied = ref<number>(0);
const isLoggedIn = ref<boolean>(false);

const applyFiltersHandler = () => {
  // Update appliedFilters
  appliedFilters.value = JSON.parse(JSON.stringify(filters.value));
  lastSearch.value = appliedFilters.value;
  applyFiltersEvent.value++;
  numberFiltersApplied.value = 0;
  appliedFilters.value.forEach((filter)=>{
    if(Array.isArray(filter.value)){
      if(filter.value.length>0) {
        numberFiltersApplied.value++
      }
    }
    else if(filter.value!=filter.defaultValue){
      if(filter.id!='distance' || (filter.id=='distance' && filter.value>0))numberFiltersApplied.value++
    }
    lastNumFiltersApplied.value = numberFiltersApplied.value;
  })
  // Update the distance based on filters
  const distanceFilter = filters.value.find((filter) => filter.id === 'distance');
  distance.value = distanceFilter?.value || 0;
};

const clearFiltersHandler = ()=>{
  filters.value.forEach((filter, idx) => {
    if(filter.clearable){
      filters.value[idx].value = filters.value[idx].defaultValue;
    }
  });
  applyFiltersHandler();
}

onMounted(async()=>{
  isLoggedIn.value = await Session.doesSessionExist();
  if (lastSearch.value.length>0){
    filters.value = lastSearch.value;
    applyFiltersHandler();
  }
  else{
    fetchAndCombineFilters().then((combinedFilters) => {
        filters.value = combinedFilters;
      applyFiltersHandler();
    });
  }
})

</script>

<style lang="scss" scoped>
@import 'MarketPage';
</style>